import React from 'react';
import { Container, DivFlexCenter, DivTextAlignCenter, CircleButton, ImageHeader, Subtitle, Title, DivLogo } from '../../styles/styles';
import Logo from '../../assets/seclogoanimado.gif'
import QRCode from 'react-qr-code';
import PoweredBy from '../../assets/powered by@2x.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { IAvulso } from '../../types/TicketInterface';
import moment from 'moment';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

function ViewTicket() {

    var ticket = JSON.parse(localStorage.getItem('ticket')!) as IAvulso;

    document.addEventListener("DOMContentLoaded", function(e) {
        document.getElementById('nomeEstacionamento')!.innerHTML += ' ' + ticket.regestacionamento.strnome;
        document.getElementById('codigoTicket')!.innerHTML = ticket.strcodigo;
        document.getElementById('dataTicket')!.innerHTML = moment.utc(ticket.datentrada).format('DD/MM/YYYY HH:mm:ss');
    });

    let goToLastPage = () => {
        window.history.go(-1);
      }

    return(
        <>
        <DivFlexCenter>
            <CircleButton style={{width: '3.5em', height: '3.5em', backgroundColor: '#FFF', color: '#CE6B00'}} onClick={goToLastPage}>
                <span>
                    <FontAwesomeIcon size='2x' icon={faTimes as IconProp}/>
                </span>
            </CircleButton>
        </DivFlexCenter>
        
        <DivFlexCenter>
            <Container className='mt-4 mb-2'>
                <DivTextAlignCenter>
                    <ImageHeader src={Logo} />

                    <hr/>

                    <Subtitle>
                            Estabelecimento
                    </Subtitle>
                    <br />
                       <label id='nomeEstacionamento' className='text-muted'>
                    </label>

                <br />

                    <QRCode className='mt-4' value={ticket.strcodigo} level='L' size={180} />
                </DivTextAlignCenter>

                <div className='mt-4'>
                    <Subtitle>
                        Ticket:
                    </Subtitle>
                    <label className='text-muted ml-1' id='codigoTicket'></label>

                    <br />

                    <Subtitle>
                        Data/Hora:
                    </Subtitle>
                    <label className='text-muted ml-1' id='dataTicket'></label>
                    
                </div>

                <hr />

                <DivTextAlignCenter>
                    <img src={PoweredBy} />
                </DivTextAlignCenter>
                
            </Container>
        </DivFlexCenter>
        </>
    );
}

export default ViewTicket;